import React from "react";
import { Box, Container, Typography, Link } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

function Footer() {
    return (
        <Box
            sx={{
                backgroundColor: "#141b2d",
                paddingY: 3,
                boxShadow: "0 -2px 8px rgba(0,0,0,0.1)",
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: "center", marginBottom: 3 }}>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, marginBottom: 2, flexWrap: "wrap" }}>
                        <Link 
                            href="https://travelnet.in/privacy-policy" 
                            underline="none" 
                            sx={{ 
                                color: "#fff", 
                                fontWeight: "400",
                                "&:hover": { 
                                    color: "#70d8bd" 
                                }, 
                                fontSize: "0.9375rem" 
                            }}
                        >
                            Privacy Policy
                        </Link>
                        <Link 
                            href="https://travelnet.in/terms-and-conditions" 
                            underline="none" 
                            sx={{ 
                                color: "#fff", 
                                fontWeight: "400",
                                "&:hover": { 
                                    color: "#70d8bd" 
                                }, 
                                fontSize: "0.9375rem" 
                            }}
                        >
                            Terms & Conditions
                        </Link>
                        <Link 
                            href="https://travelnet.in/cancellation-policy" 
                            underline="none" 
                            sx={{ 
                                color: "#fff", 
                                fontWeight: "400",
                                "&:hover": { 
                                    color: "#70d8bd" 
                                }, 
                                fontSize: "0.9375rem" 
                            }}
                        >
                            Cancellation Policy
                        </Link>
                    </Box>

                    <Box sx={{ display: "flex", justifyContent: "center", gap: 3, flexWrap: "wrap" }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <EmailIcon sx={{ fontSize: 20, color: "#70d8bd" }} />
                            <Link 
                                href="mailto:info@perfecthandssolutions.com" 
                                underline="none" 
                                sx={{ 
                                    color: "#70d8bd",
                                    fontSize: "0.9375rem"
                                }}
                            >
                                info@perfecthandssolutions.com
                            </Link>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <PhoneIcon sx={{ fontSize: 20, color: "#70d8bd" }} />
                            <Link 
                                href="tel:+918129867777" 
                                underline="none" 
                                sx={{ 
                                    color: "#70d8bd",
                                    fontSize: "0.9375rem"
                                }}
                            >
                                +91 812 986 7777
                            </Link>
                        </Box>
                    </Box>
                </Box>

                <Box sx={{ borderTop: "1px solid #333", paddingTop: 2, marginTop: 3, textAlign: "center" }}>
                    <Typography variant="body2" sx={{ color: "#fff", fontSize: "0.875rem" }}>
                        © 2025 Travelnet. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}

export default Footer;